import React from "react";
import { Group } from "@dreambigger/design-system";
import { Event as EventType, Community } from "@dreambigger/shared/src/types";
import { useGA } from "@dreambigger/shared/src/hooks";

type EventBreadCrumbs = {
  event: EventType;
  community: Community;
};

const EventBreadcrumbs = ({ event, community }: EventBreadCrumbs) => {
  // Set up analytics
  const googleAnalytics = useGA();

  const handleClick = (name: string) => () => {
    googleAnalytics.event({
      category: "External Breadcrumb Item",
      action: "Selected",
      label: "Breadcrumb Name - ",
      value: 1,
    });
  };

  // Returns breadcrumb in the format of "CommunityName / Events / EventName"
  return (
    <Group xs="horizontal" spacing={2} className="mb-1 md_mb-5 flex-wrap">
      {/* CommunityName */}
      <a
        className="hlight-primary fwb f-2 md_f-4"
        href={`/community/${community.slug}/detail`}
        onClick={handleClick(community?.slug || "community feed")}
      >
        {community.organization.name}
      </a>
      <span className="usn f-2 md_f-4">/</span>
      {/* Events */}
      <a
        className="hlight-primary fwb f-2 md_f-4"
        href={`/community/${community.slug}/events`}
        onClick={handleClick(community?.slug || "community events")}
      >
        {/* Example Keyword: "Projects" */}
        {community.meta?.marketing?.keywordUpper + "s" || "Events"}
      </a>
      <span className="usn f-2 md_f-4">/</span>
      {/* EventName */}
      <a
        className="primary fwb f-2 md_f-4"
        href={`/events/${event.id}/detail`}
        onClick={handleClick(event?.name || "event page")}
      >
        {event.name}
      </a>
    </Group>
  );
};
export default EventBreadcrumbs;
